<div class="card-body">
  <div class="row mb-2">
    <div
      class="col-md-12"
      *ngIf="
        statusDescription == 'Liberada para Operar' &&
        canShowGroup([groups.GestoresMaster || groups.GestoresBoleta])
      "
    >
      <button class="btn btn-primary" (click)="showChildModal()">
        Cadastrar Nova Ordem
      </button>
    </div>
  </div>

  <div class="row mb-2 tickets-list">
    <table
      *ngIf="ticketsList && ticketsList.length > 0"
      class="table table-striped table-hover"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col">Visualizar</th>
          <th scope="col">Código</th>
          <th scope="col">Papel</th>
          <th scope="col">Quantidade</th>
          <th scope="col">Financeiro</th>
          <th scope="col">Status</th>
          <th scope="col">Data de Criação</th>
          <th scope="col">Data de Liquidação</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of ticketsList">
          <td>
            <a (click)="showChildModal(item.id)">
              <fa-icon [icon]="faListAlt" title="Visualizar"></fa-icon>
            </a>
          </td>
          <td>{{ item.id }}</td>
          <td>{{ item.assetType }}</td>
          <td>{{ item.amount }}</td>
          <td>
            {{
              item.operationValue
                | currency : "R$" : "symbol" : "1.2-2"
            }}
          </td>
          <td>{{ item.statusDescription ?? "Em Elaboração" }}</td>
          <td>
            {{ item.operationDate | date : "dd/MM/yyyy HH:mm" : "GMT-3" }}
          </td>
          <td>
            {{ item.settlementDate | date : "dd/MM/yyyy HH:mm" : "GMT-3" }}
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td class="text-center">
            Total: <strong>{{ amountSum }}</strong>
          </td>
          <td class="text-center">
            Total:
            <strong>{{
              financialSum | currency : "R$" : "symbol" : "1.2-2"
            }}</strong>
          </td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>

<div
  bsModal
  #childModal="bs-modal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="modalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-body">
        <app-ordem-operacao-estruturada
          [mainTicketId]="mainTicketId"
          [orderId]="orderId"
          (closePage)="closePage($event)"
          (reloadTickets)="reloadTickets()"
          (openPage)="showChildModal($event)"
          [totalApprovedAssetsValue]="totalApprovedAssetsValue"
          [totalApprovedAssetsAmount]="totalApprovedAssetsAmount"
          [totalOrdersValue]="financialSum"
          [totalOrdersAmount]="amountSum"
          [biggestLimitTimestamp]="biggestLimitTimestamp"
          [structuredOperationAssetId]="structuredOperationAssetId"
          [structuredOperationAssetSubtypeId]="structuredOperationAssetSubtypeId"
        >
        </app-ordem-operacao-estruturada>
      </div>
    </div>
  </div>
</div>
